import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Page from 'flarum/common/components/Page';
import listItems from 'flarum/common/helpers/listItems';
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import Button from 'flarum/common/components/Button';
import MoneyLeaderboardListItem from "./MoneyLeaderboardListItem";
export default class MoneyLeaderboardIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.moreResults = false;
    this.moneyLeaderboardList = [];
    this.totalLoadCount = 0;
    this.additionalInfo = app.forum.attribute("moneyLeaderBoardAdditionalInfo");
    this.maxLoadCount = app.forum.attribute("leaderboardMaxLoadCount") || 50;
    this.initloadCount = app.forum.attribute("leaderboardInitLoadCount") || 20;
    this.loadMoreCount = app.forum.attribute("leaderboardLoadMoreCount") || 10;
    if (app.forum.attribute('allowViewLeaderbaord')) this.loadResults(0, this.initloadCount);else this.loading = false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const titleText = app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-title");
    app.setTitle(titleText);
    app.setTitleCount(0);
    app.current.set('titleControlLabel', titleText);
  }
  view() {
    let loading;
    let rankID = 0;
    if (this.loading) {
      loading = LoadingIndicator.component({
        size: "large"
      });
    }
    return m("div", {
      className: "MoneyLeaderboardPage"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "sideNavContainer"
    }, m("nav", {
      className: "IndexPage-nav sideNav"
    }, m(IndexSidebar, null)), m("div", {
      class: "MoneyLeaderboardContainer"
    }, m("div", {
      class: "MoneyLeaderboardListTitle"
    }, app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-title")), this.additionalInfo && this.additionalInfo.length > 0 && m("p", {
      class: "MoneyLeaderboardListAdditionalInformation"
    }, this.additionalInfo), m("div", {
      class: "MoneyLeaderboardListHeader"
    }, m("div", {
      class: "MoneyLeaderboardListHeaderRank"
    }, app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-rank")), m("div", {
      class: "MoneyLeaderboardListHeaderUser"
    }, app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-user")), m("div", {
      class: "MoneyLeaderboardListHeaderMoney"
    }, app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-money"))), m("ul", {
      class: "MoneyLeaderboardList"
    }, this.moneyLeaderboardList.map(leaderboardListItem => {
      rankID++;
      return m("li", {
        class: "MoneyLeaderboardListItems"
      }, MoneyLeaderboardListItem.component({
        leaderboardListItem,
        rankID
      }));
    })), !this.loading && this.moneyLeaderboardList.length === 0 && m("div", null, m("div", {
      style: "font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;"
    }, app.forum.attribute('allowViewLeaderbaord') ? app.translator.trans("ziven-money-leaderboard.forum.leaderboard-list-empty") : '登录后可查看积分排行榜')), !loading && this.hasMoreResults() && m("div", {
      style: "text-align:center;padding:20px"
    }, m(Button, {
      className: 'Button Button--primary',
      disabled: this.loading,
      loading: this.loading,
      onclick: () => this.loadMore()
    }, app.translator.trans('ziven-money-leaderboard.forum.leaderboard-load-more'))), loading && m("div", {
      className: "MoneyLeaderboard-loadMore"
    }, loading)))));
  }
  hasMoreResults() {
    return this.moreResults && this.maxLoadCount > this.moneyLeaderboardList.length;
  }
  loadMore() {
    this.loading = true;
    this.loadResults(this.moneyLeaderboardList.length, this.loadMoreCount);
  }
  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.moneyLeaderboardList, results);
    this.loading = false;
    m.redraw();
    return results;
  }
  loadResults(offset, loadCount) {
    if (offset === void 0) {
      offset = 0;
    }
    if (loadCount === void 0) {
      loadCount = 20;
    }
    if (this.moneyLeaderboardList.length >= this.maxLoadCount) {
      return;
    }
    const limit = Math.min(loadCount, this.maxLoadCount - this.moneyLeaderboardList.length);
    return app.store.find("moneyLeaderboard", {
      page: {
        offset,
        limit
      }
    }).catch(error => {
      this.loading = false;
      m.redraw();
      throw error;
    }).then(this.parseResults.bind(this));
  }
}
flarum.reg.add('ziiven-money-leaderboard', 'forum/components/MoneyLeaderboardIndexPage', MoneyLeaderboardIndexPage);